import React from "react";
import {Card} from "../../../../components/card/card.jsx";
import projectUtils from "../../../../utils/project-utils.js";
import {getBackgroundImage} from "../utils/individual-alarm-utils.js";

const IndividualAlarmCard = ({alarm, openModal, onCardClick}) => {
    const imagePath = getBackgroundImage(alarm?.individualMatchesModels);

    const situations = (alarm?.individualMatchesModels ?? [])
        .map(item => item?.data?.individualData?.situations ?? [])
        .reduce((acc, list) => {
            list.forEach(situation => {
                if (!acc.includes(situation)) acc.push(situation);
            });
            return acc;
        }, []);

    const origins = [...new Set(
        (alarm?.individualMatchesModels ?? [])
            .flatMap(match => [match?.entity?.entityName, match?.cameraName])
            .filter(Boolean)
    )].join(", ");

    return (
        <div className={"w-full mt-2"}>
            {
                alarm?.individualMatchesModels &&
                <Card className={"cursor-pointer"} onClick={() => onCardClick(alarm)}>
                    <Card.Body className={"flex gap-3 flex-nowrap"}>
                        <div
                            className={"ia-img-facial-recognition shrink-0"}
                            style={{height: "90px", width: "130px", backgroundImage: `url(${imagePath})`}}
                            onClick={(e) => openModal(e, imagePath)}
                        />
                        <div className={"min-w-0 self-center space-y-2"} style={{lineHeight: "8px"}}>
                            <div className={"flex gap-1 flex-wrap"}>
                                {
                                    situations.map((situation, index) => (
                                        <div key={index}>
                                            <h4 className={"ia-situation-badge"} style={{whiteSpace: "nowrap", width: "min-content"}}>{situation}</h4>
                                        </div>
                                    ))
                                }
                            </div>

                            <h4 className={"font-bold"}>{projectUtils.formatCpfToView(alarm.individualDocument)}</h4>

                            <h4 style={{fontWeight: "normal"}}>{origins}</h4>

                            <h4 style={{fontWeight: "normal"}}>{projectUtils.formatDate(alarm.createdAt, "DD/MM/YYYY hh:mm:ss")}</h4>
                        </div>
                    </Card.Body>
                </Card>
            }
        </div>
    );
};

export default IndividualAlarmCard;
